<template>
  <v-container class="limited">
    <v-layout column>
      <beneficiary-data></beneficiary-data>
      <v-card class="elevation-5 mb-4 px-5 py-3">
        <div>
          <h1 class="subheading font-weight-black primary--text mt-3">
            Relatório de dados pessoais
          </h1>
          <v-layout row wrap align-center justify-start
            ><h1
              class="subheading font-weight-black grey--text text--darken-2"
              :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
            >
              para cumprimento da LGPD é obrigação do sistema fornecer um
              relatório dos dados pessoais existentes do titular.
            </h1>
          </v-layout>
          <v-layout row wrap align-center justify-start>
            <v-btn
              color="primary"
              class="mg-0 white--text"
              dark
              :disabled="!dadosBeneficiario.titular"
              :loading="loadingDownload"
              @click="downloadRelatorioDadosTitular"
            >
              GERAR RELATÓRIO
              <v-icon right>download</v-icon>
            </v-btn>
          </v-layout>
        </div>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { buscaDadosTitular } from "@/services/reports";

import BeneficiaryData from "@/components/BeneficiaryData";

import { downloadCsv } from "@/utils/relatorio.js";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "ReportDadosTitular",
  components: {
    BeneficiaryData
  },
  data() {
    return {
      loadingDownload: false
    };
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapState(["highContrast"])
  },
  methods: {
    ...portalStore.mapMutations(["setErrorToast"]),
    downloadRelatorioDadosTitular() {
      this.loadingDownload = true;
      const codigoBeneficiario = this.dadosBeneficiario?.id;

      buscaDadosTitular(codigoBeneficiario)
        .then(data => {
          if (data) downloadCsv(data, "RelatorioDadosTitular.csv");
        })
        .catch(({ data }) => {
          if (!data) {
            this.$toast.warning(
              "Não foram encontrados dados para os filtros informados."
            );
          }
        })
        .finally(() => {
          this.loadingDownload = false;
        });
    }
  }
};
</script>
<style>
.mg-0 {
  margin: 15px 0 0 0;
}
</style>
